import { render, staticRenderFns } from "./InviteDetail.vue?vue&type=template&id=0ec0fcab&scoped=true&"
import script from "./InviteDetail.vue?vue&type=script&lang=js&"
export * from "./InviteDetail.vue?vue&type=script&lang=js&"
import style0 from "./InviteDetail.vue?vue&type=style&index=0&id=0ec0fcab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec0fcab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
